module.exports = __webpack_public_path__ + "static/media/hashimoto.ae496f76.gif";